import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall3BadgeCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333m2.516 5.422a.667.667 0 0 0-1.032-.844L6.95 9.008l-.812-.813a.667.667 0 1 0-.943.943l1.334 1.333a.667.667 0 0 0 .987-.049z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaywall3BadgeCheck;
